import React from 'react';
import AIDashboard from '@/features/cms/components/AIDashboard';

const CmsAiPage: React.FC = () => (
  <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
    <AIDashboard />
  </div>
);

export default CmsAiPage;
